<template>
  <div
    :data-id="page.encrypted_id"
    :class="{
      'box box-page builder-container-list-websites_card-box-pages': type_view === 'card',
      'builder-container-list-websites_card-list-pages': type_view === 'list'
    }"
  >
    <template v-if="type_view === 'list'">
      <div class="box-all-checked">
        <div class="form-check pl-0 pr-2">
          <input
            v-if="selectPages.type === 'all'"
            :checked="selectPages.type === 'all'"
            type="checkbox"
            @click.prevent="checkedSelectAll(page.id)">

          <input
            v-show="selectPages.type !== 'all'"
            :id="`selected-user-${page.id}`"
            :value="page.id"
            v-model="selectPages.selectedPages"
            type="checkbox"
            @change="changeUnitary()">
        </div>
      </div>

      <div
        :class="reordering ? 'reordering' : ''"
        :style="`background-image: url('${(page.configuration && page.configuration.og_image) ? page.configuration.og_image: '/static/images/cheetah-og.png'}');`"
        class="card-list-image-container"
      >
        <div
          v-if="reordering"
          class="card-list-image-upload-overlay"
        >
          <a
            :title="$t('ct-sort')"
            data-placement="right"
            data-toggle="tooltip"
          >
            <i
              class="mdi mdi-cursor-move drag"
              style="width: 30px; height: 30px; color: #fff; font-size: 30px;"/>
          </a>
        </div>
        <div
          v-else-if="page && page.url"
          class="card-list-image-upload-overlay"
        >
          <router-link
            v-if="!page.is_turbo"
            :to="{name: 'editor', params: { page_id : page.encrypted_id } }"
            class="btn-edit-website"
            target="_blank"
          >{{ $t('ct-card-site-edit') }}
          </router-link>
          <router-link
            v-else
            :to="{name: 'CheetahTurboPageEdit', params: { id: website.encrypted_id, page_id : page.encrypted_id } }"
            class="btn-edit-website"
            target="_blank"
          >{{ $t('ct-card-site-edit') }}
          </router-link>
        </div>
      </div>

      <div class="card-list-info-container">
        <span
          v-tooltip.right="{content: $t('ct-card-sitepage-edit'), class: 'ba-tooltip-custom'}"
          class="title-principal"
          @click="openSettingsPage(page)">{{ pageName }}</span>
        <span
          v-tooltip="{content: $t('ct-acess-page'), class: 'ba-tooltip-custom'}"
          class="url-access-website"
          @click.prevent="goToWebsitePage"
        >{{ pageUrl }}</span>
      </div>

      <pages-actions
        :page="page"
        :website="website"
        :is-unpublish="isUnpublish"
        class="card-list-options"
        @goToWebsitePage="goToWebsitePage"
        @openSettingsPage="openSettingsPage"
        @confirmDelete="confirmDelete"
        @uploadImagePage="uploadImagePage"
        @openVersionsPage="openVersionsPage"
        @duplicatePageData="duplicatePageData"
      />

    </template>

    <template v-else>
      <div class="box-body">
        <div class="box-group-icon">
          <div class="box-all-checked">
            <div class="form-check pl-0 pr-2">
              <input
                v-if="selectPages.type === 'all'"
                :checked="selectPages.type === 'all'"
                type="checkbox"
                @click.prevent="checkedSelectAll(page.id)">

              <input
                v-show="selectPages.type !== 'all'"
                :id="`selected-user-${page.id}`"
                :value="page.id"
                v-model="selectPages.selectedPages"
                type="checkbox"
                @change="changeUnitary()">
            </div>
          </div>

          <div v-if="page.initial" class="box-home-left">{{ $t('ct-home') }}</div>
          <div v-if="page.is_turbo" class="box-icon-left box-turbo-left">
            <i class="svg-icon svgi-sm svgi-rocket"/>
          </div>
          <div v-if="page.is_blog" class="box-blog-left">{{ $t('ct-blog') }}</div>
          <div v-if="page.is_member" class="box-is_member-left">{{ $t('ct-page-is-member') }}</div>

          <template v-if="page.restrict_areas && page.restrict_areas.length > 0">
            <div
              v-tooltip="{content: restrict.name, class: 'tooltip-custom'}"
              v-for="(restrict, index) in page.restrict_areas"
              :key="index"
              :style="{ 'background-color': restrict.color }"
              class="box-icon-left-sm ml-auto" />
          </template>
        </div>
        <div
          :class="reordering ? 'reordering' : ''"
          :style="`background-image: url('${(page.configuration && page.configuration.og_image) ? page.configuration.og_image: '/static/images/cheetah-og.png'}');`"
          class="box-image-container"
        >
          <div
            v-if="reordering"
            class="box-upload-overlay"
          >
            <a
              :title="$t('ct-sort')"
              data-placement="right"
              data-toggle="tooltip"
            >
              <i
                class="mdi mdi-cursor-move drag"
                style="width: 70px; height: 70px; color: #fff; font-size: 70px;"/>
            </a>
          </div>
          <div
            v-else-if="page && page.url"
            class="box-upload-overlay"
          >
            <router-link
              v-if="!page.is_turbo"
              :to="{name: 'editor', params: { page_id : page.encrypted_id } }"
              class="btn-edit-website"
              target="_blank"
            >{{ $t('ct-card-site-edit') }}
            </router-link>
            <router-link
              v-else
              :to="{name: 'CheetahTurboPageEdit', params: { id: website.encrypted_id, page_id : page.encrypted_id } }"
              class="btn-edit-website"
              target="_blank"
            >{{ $t('ct-card-site-edit') }}
            </router-link>
          </div>
        </div>
      </div>
      <div :class="page.is_turbo ? 'turbo-bg' : ''" class="box-footer">
        <div class="box-info">
          <span
            v-tooltip.right="{content: $t('ct-card-sitepage-edit'), class: 'ba-tooltip-custom'}"
            class="title-principal"
            @click="openSettingsPage(page)">{{ pageName }}</span>
          <span
            v-tooltip="{content: $t('ct-acess-page'), class: 'ba-tooltip-custom'}"
            class="url-access-website"
            :class="{'is-published': !isUnpublish}"
            @click.prevent="goToWebsitePage"
          >{{ pageUrl }}</span>
        </div>

        <pages-actions
          :page="page"
          :website_id="website.encrypted_id"
          :is-unpublish="isUnpublish"
          class="box-options"
          @goToWebsitePage="goToWebsitePage"
          @openSettingsPage="openSettingsPage"
          @confirmDelete="confirmDelete"
          @uploadImagePage="uploadImagePage"
          @openVersionsPage="openVersionsPage"
          @duplicatePageData="duplicatePageData"
        />
      </div>
    </template>
  </div>
</template>

<script>
import {duplicate as duplicatePage} from "../../../../js/services/editor/page";
import PagesActions from "./pages/PagesActions.vue";

export default {
  name: "SitePageCard",
  components: {PagesActions},
  props: ['page', 'website', 'reordering', 'type_view', 'selectPages', 'isUnpublish'],
  computed: {
    pageName() {
      const name = this.page.name;
      return name.length > 33 ? name.substring(0, 33) + '...' : name;
    },
    pageUrl() {
      const url = this.page.url;
      return url.length > 40 ? url.substring(0, 37) + '...' : url;
    }
  },

  methods: {
    openSettingsPage() {
      this.$router.push({name: 'SitePageEdit', params: {page_id: this.page.encrypted_id}});
    },

    goToWebsitePage() {
      this.$emit('goToWebsitePage', this.page);
    },

    openVersionsPage() {
      this.$router.push({name: 'SitePageVersions', params: {page_id: this.page.encrypted_id}});
    },

    uploadImagePage() {
      this.$emit('uploadImagePage', this.page);
    },

    confirmDelete(type) {
      this.$emit('confirmDelete', type, this.page);
    },

    checkedSelectAll(website_id) {
      this.$emit('checkedSelectAll', website_id);
    },

    changeUnitary() {
      this.$emit('changeUnitary');
    },

    duplicatePageData() {
      this.$loading.show();

      duplicatePage(this.page).then(res => {
        if (res.data.success) {
          this.updateData();
          this.$snotify.success(this.$t('ct-page-duplicated'));
        } else
          this.$snotify.error(res.data.error);

      })
        .finally(() => {
          this.$loading.hide();
          window.location.reload();
        });
    }
  }
};

</script>

<style lang="scss" scoped>
.box:not(.new-page) {
  .box-info {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}

.box-group-icon {
  position: absolute;
  padding: 16px 20px;
  // left: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: start;
  flex-flow: wrap;
}

.box-icon-left-sm {
  width: 25px;
  height: 25px;
  background-color: #000000;
}

.box-icon-left {
  width: 25px;
  height: 25px;
  background-color: #0080FC;
}

.box-turbo-left {
  width: 25px;
  height: 25px;
  padding-bottom: 4px;
  background: #6563FF;
}

.box-home-left {
  width: auto;
  background: #0072E1;
  border-radius: 4px;
  padding: 4px 16px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  color: #FFFFFF;
  margin-right: 10px;
}

.box-blog-left {
  width: auto;
  background-color: #ff9800;
  color: #FFF;
  display: inline-block;
  padding: 4px 16px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  border-radius: 5px;
}

.box-is_member-left {
  width: auto;
  background-color: #644588;
  color: #FFF;
  display: inline-block;
  padding: 4px 16px;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  border-radius: 4px;
}

.box-icon-left, .box-icon-left-sm {
  display: inline-flex;
  color: #FFF;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  // margin-right: 10px;

  .svg-inline--fa {
    vertical-align: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SitePageCard.vue